<template>
  <div>
    <h2>Settings</h2>
    <input type="text" placeholder="Name" v-model="userInfo.name" /><button
      @click="save"
    >
      Save
    </button>
  </div>
</template>

<script>
export default {
  name: "Settings",
  methods: {
    save() {
      this.$storage.save();
    }
  },
  computed: {
    userInfo() {
      return this.$storage._userInfo;
    }
  }
};
</script>

<style scoped></style>
